import { RouteObject, useRoutes } from "react-router-dom";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getLoginResult } from "@/store/selectors";
import { PostUserLoginResult } from "@/request/modules/gen_api_4041";
import service_routers from "@/router/routers/service_routers";
import admin_routers from "@/router/routers/admin_routers";
import base_routers from "@/router/routers/base_routers";
import region_routers from "@/router/routers/region_routers";
import { Layout } from "antd";
import { css } from "@emotion/css";

const layout_css = css`
    height: 100vh;
`;

export default () => {

    const loginResult = useSelector(getLoginResult);

    const routers_map: Record<PostUserLoginResult["role"], RouteObject[]> = {
        1: [],
        2: service_routers,
        3: region_routers,
        20: admin_routers,
    }

    const routers = useMemo<RouteObject[]>(() => {
        let role_routers: RouteObject[] = [];
        if (!!loginResult) role_routers = routers_map[loginResult.role];
        return role_routers.concat(base_routers);
    }, [loginResult]);

    return (
        <Layout className={layout_css}>
            {useRoutes(routers)}
        </Layout>
    );
}